import {Grid, TextField, Typography} from "@mui/material";
import {useLocation} from "react-router";

function Recipe() {
    const loc = useLocation();
    const recipe = loc.state?.doughRecipe || {
        flour: 0,
        water: 0,
        salt: 0,
        yeast: 0,
        yeastType: 0
    };

    return (
        <Grid container spacing={2} alignItems={"center"} justifyContent={"space-around"} padding={"1em"}>
            <Grid item xs={12}>
                <Typography variant={"subtitle1"}>Rezept</Typography>
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label={"Mehl"}
                    variant={"outlined"}
                    value={recipe.flour.toFixed(1)}

                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label={"Wasser"}
                    variant={"outlined"}
                    value={recipe.water.toFixed(1)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label={"Öl"}
                    variant={"outlined"}
                    value={recipe.oil.toFixed(1)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label={"Salz"}
                    variant={"outlined"}
                    value={recipe.salt.toFixed(2)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label={"Hefe"}
                    variant={"outlined"}
                    value={recipe.yeast.toFixed(2)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    variant={"outlined"}
                    label={"Hefetyp"}
                    value={
                        recipe.yeastType === 'activeDry' ? 'Trocken' : 'Frisch'
                    }
                />
            </Grid>
        </Grid>
    );
}

export default Recipe;